import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-assignation-sidebar-panel',
  templateUrl: './assignation-sidebar-panel.component.html',
  styleUrls: ['./assignation-sidebar-panel.component.css'],
})
export class AssignationSidebarPanelComponent {
  @Input() includedDrivers = 0;
  @Input() totalDrivers = 0;
  @Input() isLoadingDrivers = false;

  @Output() viewAll = new EventEmitter<void>();

  get hasAssignedDrivers(): boolean {
    return this.includedDrivers > 0;
  }

  onViewAll(): void {
    if (this.isLoadingDrivers) {
      return;
    }

    this.viewAll.emit();
  }
}
